import { h } from "preact";

// Helper Functions
const degToRad = (degrees) => {
  return degrees * (Math.PI / 180);
}

// Drawing Functions
const drawPhoto = (p, c, ctx, fw, mw, pb) => {
  let pOffset = fw + pb + mw,
  dOffset = pOffset * 2;
  ctx.save();
  ctx.drawImage(p, pOffset, pOffset, c.width - dOffset, c.height - dOffset);
  ctx.restore()
}

const drawShadow = (c, ctx, fw, mw) => {
  let offset = fw / 2,
  pOffset = 4;
  ctx.save();
  ctx.beginPath();
  ctx.shadowColor='rgba(0,0,0,.2)';
  ctx.shadowOffsetY = pOffset;
  ctx.shadowOffsetX = 0;
  ctx.shadowBlur= pOffset;
  ctx.lineWidth = fw;
  ctx.strokeStyle = "white";
  ctx.rect(offset, offset, c.width - offset - pOffset, c.height - offset);
  ctx.stroke();
  ctx.restore()
}

const drawMatting = (c, ctx, fw, mw, mc) => {
  let lineOffset = mw / 2 + fw; 
  ctx.save();
  ctx.beginPath();
  ctx.shadowColor='rgba(0,0,0,.2)';
  ctx.shadowBlur=10;
  ctx.lineWidth = mw;
  ctx.strokeStyle = mc;
  ctx.rect(lineOffset, lineOffset, c.width - lineOffset * 2, c.height - lineOffset * 2);
  ctx.stroke();
  ctx.restore()
}

// Render Function
export const renderCanvas = (app, callback) => {
  // Canvas and Context
  const c = document.getElementById('canvas');
  let f = app.state.selectedItems['frame'] ? app.state.selectedItems['frame'].image : false,
  fw = app.state.selectedItems['frame'] ? app.state.selectedItems['frame'].fWidth * 50 : false,
  ps = app.state.selectedItems['artwork'] ? app.state.selectedItems['artwork'].url : false,
  pb = app.state.selectedSizes['print_border'] ? app.state.selectedSizes['print_border'] * 50 : 0,
  mc = app.state.selectedItems['matting'] && app.state.selectedItems['matting'].hex ? app.state.selectedItems['matting'].hex : "#FFFFFF",
  mw = app.state.selectedSizes['matting'] && app.state.selectedItems['matting'] ? app.state.selectedSizes['matting'] * 50 : 0;
  f = (app.state.selectedItemInfo && app.state.selectedItemInfo['frame'] && app.state.selectedItemInfo['frame'].image) ? app.state.selectedItemInfo['frame'].image : f;
  fw = (app.state.selectedItemInfo && app.state.selectedItemInfo['frame'] && app.state.selectedItemInfo['frame'].fWidth) ? app.state.selectedItemInfo['frame'].fWidth * 50 : fw;


  if (!c) return;
  let size = {width: app.state.selectedSizes['width'] ? app.state.selectedSizes['width'] * 50 : 8*50, length: app.state.selectedSizes['length'] ? app.state.selectedSizes['length'] * 50 : 10*50},
  ctx = c.getContext('2d');

  
  // Images
  let frame = f ? new Image() : false;
  if (f) {
    frame.src = `${app.state.imgBase}${f}`;
    frame.crossOrigin = "Anonymous";
  };
  let p = ps ? new Image() : false;
  if (p) {
    p.src = ps;
    p.crossOrigin = "Anonymous";
  };

  // Sizing
  let ratio = size.width / size.length,
  fratio = 0,
  fh = 0,
  flw = 25;
  
  // CTX Updates
  ctx.imageSmoothingEnabled = false;
  ctx.clearRect(0, 0, c.width, c.height);
  
  const photoLoad = new Promise((resolve, reject) => {
    if (!p) resolve();
    p.addEventListener('load', e => {
      resolve();
    });
  });
  const frameLoad = new Promise((resolve, reject) => {
    if (!frame) resolve();
    frame.addEventListener('load', e => {
      fratio = fw / frame.width;
      fh = frame.height * fratio,
      resolve();
    });
  });

  Promise.all([photoLoad, frameLoad]).then((values) => {

    // Update Values
    c.width = size.width + (fw * 2) + (mw * 2) + (pb * 2);
    c.height = size.length + (fw * 2) + (mw * 2) + (pb * 2);
    ratio = c.width / c.height;

    // Draw New Canvas
    p && drawPhoto(p, c, ctx, fw, mw, pb);
    drawMatting(c, ctx, fw, mw, mc);
    frame && drawShadow(c, ctx, fw, mw);
    frame && drawFrame(fw, ratio);
    callback()
  });

  function clippedPath(pathPoints, fh, fw, rot, offset){
    ctx.save();

    // Create Path
    ctx.beginPath();
    ctx.moveTo(pathPoints[0],pathPoints[1]);
    ctx.lineTo(pathPoints[2],pathPoints[3]);
    ctx.lineTo(pathPoints[4],pathPoints[5]);
    ctx.closePath();    
    
    // Clip Path
    ctx.clip();
    ctx.translate(c.width/2,c.height/2);
    ctx.rotate(degToRad(rot));

    drawHorizontalBorder(fh, fw, offset)

    ctx.restore();
  }
  
  function drawFrame(width, ratio){
    let offset = fw,
    caTop = c.height / 2 * ratio,
    caBottom = c.height / 2 * (2 - ratio);
    ctx.save();
    drawVerticalBorder(fh, fw);
    ctx.rotate(degToRad(180));
    drawVerticalBorder(fh, fw, offset, true);
    ctx.restore()
    clippedPath([c.width / 2, caTop, c.width, 0,0,0], fh, fw, 90, offset)
    clippedPath([c.width / 2, caBottom, c.width, c.height, 0, c.height], fh, fw, 270, offset)
  }
        
  function drawVerticalBorder(fh, fw, offset = 0, right) {
      var x = right ? -c.width : 0;
      var y = right ? -c.height : 0;  
      for (var h = 0; h < c.height + offset; h += fh/2) {
        ctx.drawImage(frame, x, (y + h), fw, fh);
      }
  }

  function drawHorizontalBorder(fh, fw, offset) {
    for (var h = 0; h < c.width + offset; h += fh/2) {
      ctx.drawImage(frame, -c.height/2, (-c.width/2 + h), fw, fh);
    }
  }
}

// Canvas Component
export const VisualizerCanvas = (d) => {
  let data = d.state,
  imageData = data.selectedItems['artwork'] ? data.selectedItems['artwork'].url : false,
  frameData = data.selectedItems ? data.selectedItems['frame'] : false,
  frameSelection = data.selectedItemInfo ? data.selectedItemInfo['frame'] : false,
  bWidth = frameSelection && frameSelection.fWidth ? frameSelection.fWidth : false;
  
  if (!frameData && !frameSelection && !imageData) return;
  let length = data.selectedSizes['length'] && parseFloat(data.selectedSizes['length']),
  width = data.selectedSizes['width'] && parseFloat(data.selectedSizes['width']),
  fwidth = bWidth ? bWidth : (frameData && frameData.fWidth ? parseFloat(frameData.fWidth) : 0),
  pwidth = data.selectedSizes['print_border'] ? data.selectedSizes['print_border'] : 0,
  mwidth = data.selectedSizes['matting'] ? data.selectedSizes['matting'] : 0;

  let totalWidth = width + (fwidth * 2) + (pwidth * 2) + (mwidth * 2),
  totalLength = length + (fwidth * 2) + (pwidth * 2) + (mwidth * 2);
  // todo: add frame width


  return <section className="visualizer-frame">
    <div className={`loader ${!data.vLoaded ? 'loading' : ''}`}></div>
    
    <section className="visualizer-frame-container">
    
      <div className={`visualizer-frame-dimensions ${data.activePanel === 'frame' ? 'active' : ''}`}>
        <div className="height"><span>{totalLength}"</span></div>
        <div className="width"><span>{totalWidth}"</span></div>
      </div>
      <canvas id="canvas" className="visualizer-frame-canvas" height={totalLength * 50 } width={totalWidth * 50 } />
    </section>
  </section>
}